import { render, staticRenderFns } from "./NotificationRecipientChips.vue?vue&type=template&id=6de13c1a&scoped=true"
import script from "./NotificationRecipientChips.vue?vue&type=script&lang=js"
export * from "./NotificationRecipientChips.vue?vue&type=script&lang=js"
import style0 from "./NotificationRecipientChips.vue?vue&type=style&index=0&id=6de13c1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de13c1a",
  null
  
)

export default component.exports